import { render } from "./Money.vue?vue&type=template&id=55c55782&scoped=true"
import script from "./Money.vue?vue&type=script&lang=js"
export * from "./Money.vue?vue&type=script&lang=js"

import "./Money.vue?vue&type=style&index=0&id=55c55782&lang=less&scoped=true"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_yg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c55782"]])

export default __exports__